import { SwAlert } from "components/Common/Alert/AlertForm";
import { useEffect } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import secureLocalStorage from "react-secure-storage";
import { AuthToken, currentLanguage } from "service/CommonFunction/AxiosConfig";
import { AlertTitleTh, AxiosGet, AxiosPost, ResultAPI } from "service/CommonFunction/TS_function";
import { FnBlock_UI } from "service/SystemFunction/SystemFunction";

const GBURQForm = () => {
    const { BlockUI, UnBlockUI } = FnBlock_UI();
    const location = useLocation();
    const navigate = useNavigate();

    useEffect(() => {
        BlockUI()
        const sPathname = location.pathname;
        const queryString = location.search;
        const urlParams = new URLSearchParams(queryString);
        const nContactID = urlParams.get("contactid");
        const sAuthenID = urlParams.get("authenid");
        const sMode = urlParams.get("mode");
        const language = urlParams.get("lang");

        
        if (language != null && language != "") {
            let sLanguage = language.toLocaleLowerCase() == "en" ? "en" : "th"
            secureLocalStorage.setItem('languageUvoice', sLanguage);
        }

        if (nContactID != null) {
            const obj = {
                sContactID: nContactID,
                sAuthenID: sAuthenID
            }

            AxiosPost("Authentication/AuthenGBU", obj, (res) => {
                ResultAPI(res, null, () => {
                    if (res.result?.token) {
                        AuthToken.set(res.result.token)
                    }

                    AxiosGet(`Authentication/GBURQForm`, { sMode: sMode }, (result: any) => {
                        if (result != null && result.sPath != null) {

                            UnBlockUI()
                            navigate(result.sPath)
                        } else {
                            UnBlockUI()
                            navigate("/Home")
                        }
                    })
                })
            }, (err) => {
                navigate("/Home")
            }, null);
        } else {
            AxiosGet(`Authentication/GBURQForm`, { sMode: sMode }, (result: any) => {
                if (result != null && result.sPath != null) {

                    UnBlockUI()
                    navigate(result.sPath)
                } else {
                    UnBlockUI()
                    navigate("/Home")
                }
            })
        }
    }, [])

    return (
        <>
        </>
    )
}
export default GBURQForm;